import {
  MAX_QUESTION_SCORE,
  ROUND_TIMEOUT,
  S3_BASE_URL,
  IMAGE_QUESION_DIR
} from "../config";

const clamp = (min: number, max: number): Function => {
  return function (num: number) {
    return num > max ? max : num < min ? min : num;
  };
};

const clampScore = (num: number): number => clamp(0, MAX_QUESTION_SCORE)(num);

const clampTime = (num: number): number => clamp(0, 9)(num);

const formattedTime = function(num: number){
if(num > 9) {
  return num

}  else {
    return '0' + num
  }
};

const getQuestionImageUrl = (url: string) =>
  `${S3_BASE_URL}${IMAGE_QUESION_DIR}/${url}.jpg`;

export { clamp, clampScore, clampTime, getQuestionImageUrl, formattedTime };
